import script from "./DynamicBgComp.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicBgComp.vue?vue&type=script&setup=true&lang=js"

import "./DynamicBgComp.vue?vue&type=style&index=0&id=58eae20d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58eae20d"]])

export default __exports__